/** @module csi/action/SvgImageDropController */
define([
	"dojo/_base/declare",
	"csi/action/_ImageUploadMixin",
	"csi/action/Controller"
], function(declare,_ImageUploadMixin,Controller) {
	
	/**
	 * This controller works in conjunction with _DndHTML5Mixin and intended for use with SvgCanvasEditor widget 
	 * First add that mixin (_DndHTML5Mixin) to your widget declaration, then initialize it, and define onDrop function.
	 * Then _DndHTML5Mixin will accept dropped images and return list of dropped files to the widget
	 * Those files will be downloaded to the client and mixin returns {File[]) to the widget (see function _onDropImage() )
	 * 
	 * Then widget invokes new Action() using this controller, controller uploads images to the server - _ImageUploadMixin.preProcess();
	 * If successful it will call onSave() to add images to the widget's canvas
	 * 
	 * Example: csi/datasheet/CanvasWidget
	 */

	return declare([Controller,_ImageUploadMixin], {
		/**
		 * Add selected image(s) to canvas
		 * @param {Node[]} nodes
		 */
		onSave: function(nodes) {
			this.widget.canvasWidgetNode.addImageNodes(nodes);
		}
	});
});